import React from "react";
import { Box, Container, LinearProgress } from "@mui/material";

import { LogoHeaderCard } from "./logo-header-card";

export function FullScreenLoader() {
  return (
    <Container
      maxWidth="sm"
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <LogoHeaderCard noBorder>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <LinearProgress sx={{ width: "100%", maxWidth: "100px" }} />
        </Box>
      </LogoHeaderCard>
    </Container>
  );
}
